import React from "react";
import Img from "./img";

const TeamCard = ({ data }) => {
  const { photo, name, position } = data;
  return (
    <div className="team_member">
      <Img src={photo} alt={name} className="img-fluid" />
      <div className="team_details">
        <h3>
          <span className="skills">{position}</span>
        </h3>
        <span className="team_socials">
              {name}
        </span>
      </div>
    </div>
  );
};

export default TeamCard;
